import type { AssessmentResultData } from './types/assessment/interfaces'

import { useAssessmentResultStore } from './assessment-result-store'
import { useAssessmentResultApi } from '../api/assessments-result.hook'
import { useAssessmentResult } from './assessment-results.hook'

interface AssessmentResultLoadReturn {
  load: (assessmentId: number) => Promise<void>
}

export const useAssessmentResultLoad = (): AssessmentResultLoadReturn => {
  const assessmentResultStore = useAssessmentResultStore()
  const { initAssessmentResult } = useAssessmentResult()

  const load = async (assessmentId: number): Promise<void> => {
    const requestId = assessmentResultStore.begin(assessmentId)
    const isSuperseded = (): boolean => requestId !== assessmentResultStore.requestId

    await useAssessmentResultApi({
      params: { assessment: String(assessmentId) },
    }, {
      onSuccess: (data: AssessmentResultData) => {
        if (isSuperseded()) return

        initAssessmentResult(data)
        assessmentResultStore.settle(assessmentId, requestId)
      },
      onError: () => assessmentResultStore.fail(assessmentId, requestId),
    })
  }

  return { load }
}
